module.exports = __webpack_public_path__ + "img/3_77.d5de985e.png";